import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "fail"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "fail__img"
}, null, -1);
const _hoisted_3 = {
  class: "fail__tips"
};
const _hoisted_4 = /*#__PURE__*/_createElementVNode("li", null, "1、请确保设备和网络正常运行；", -1);
const _hoisted_5 = /*#__PURE__*/_createElementVNode("li", null, "2、更新设备固件和客户端为最新版后重试；", -1);
const _hoisted_6 = /*#__PURE__*/_createElementVNode("li", null, "3、请联系设备厂商，确认该设备支持迅雷下载。", -1);
const _hoisted_7 = {
  key: 0,
  class: "fail-cover"
};
const _hoisted_8 = {
  class: "fail-dialog"
};
const _hoisted_9 = {
  class: "dialog__body"
};
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h2", null, "错误信息", -1);
const _hoisted_11 = {
  class: "tips"
};
const _hoisted_12 = {
  class: "dialog__footer"
};
import { computed, ref } from 'vue';
import { store } from '@remote/store';
import { msToTime, formatTime } from '@remote/utils';
import { getLocalValue } from '@remote/utils/index';
import copy from 'clipboard-copy';
import '@remote/assets/css/fail.scss';
import { useDeviceStore } from '@remote/store/device';
export default /*#__PURE__*/_defineComponent({
  __name: 'Fail',
  setup(__props) {
    const clickCount = ref(0);
    const showFailBtn = ref(false);
    const connectMessage = ref('');
    const showFailDialog = ref(false);
    const deviceStore = useDeviceStore();
    const connecting = computed(() => {
      return store.state.connecting;
    });
    const curDeviceRunner = computed(() => {
      return store.state.curDeviceRunner;
    });
    const tip = computed(() => {
      var _curDeviceRunner$valu, _curDeviceRunner$valu2, _curDeviceRunner$valu3;
      return connecting.value ? '检查设备中' : (_curDeviceRunner$valu = curDeviceRunner.value) !== null && _curDeviceRunner$valu !== void 0 && _curDeviceRunner$valu.id ? `当前设备(${(_curDeviceRunner$valu2 = (_curDeviceRunner$valu3 = curDeviceRunner.value) === null || _curDeviceRunner$valu3 === void 0 ? void 0 : _curDeviceRunner$valu3.name) !== null && _curDeviceRunner$valu2 !== void 0 ? _curDeviceRunner$valu2 : ''})已离线` : '未找到可远程下载的设备';
    });
    const tipBtn = computed(() => {
      return connecting.value ? '正在连接中' : '重新连接';
    });
    const lastTime = computed(() => {
      var _deviceStore$currentD, _device$updated_time;
      const device = (_deviceStore$currentD = deviceStore.currentDeviceRef) === null || _deviceStore$currentD === void 0 ? void 0 : _deviceStore$currentD.runnerTaskRef;
      const deviceLastUpdateTime = (_device$updated_time = device === null || device === void 0 ? void 0 : device.updated_time) !== null && _device$updated_time !== void 0 ? _device$updated_time : '';
      const localDeviceTime = device && deviceLastUpdateTime ? formatTime(deviceLastUpdateTime, 'MM-dd hh:mm') : '';
      const lastUpdateTimeValue = new Date(deviceLastUpdateTime).getTime();
      const since = new Date().getTime() - lastUpdateTimeValue;
      return device && deviceLastUpdateTime ? `4、当前设备最近活跃时间为: ${localDeviceTime} (${msToTime(since / 1000)}前)` : '';
    });
    const copyClose = () => {
      copy(connectMessage.value);
      showFailDialog.value = false;
    };
    const handleRetry = () => {
      clickCount.value++;
      if (clickCount.value >= 5) {
        location.reload(); // 如果用户点了5下，就给他reload一下页面。
      }

      if (connecting.value) return;
      store.dispatch('login');
      connectMessage.value = getLocalValue('connectMessage') && JSON.stringify(getLocalValue('connectMessage'));
      showFailBtn.value = !!connectMessage.value;
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("p", null, _toDisplayString(tip.value), 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("ul", null, [_hoisted_4, _hoisted_5, _hoisted_6, _withDirectives(_createElementVNode("li", null, _toDisplayString(lastTime.value), 513), [[_vShow, lastTime.value]])])]), _createElementVNode("span", {
        class: "button-fail",
        onClick: handleRetry
      }, _toDisplayString(tipBtn.value), 1), showFailBtn.value ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "button-fb",
        onClick: _cache[0] || (_cache[0] = $event => showFailDialog.value = true)
      }, "反馈错误信息")) : _createCommentVNode("", true)]), showFailDialog.value ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("p", _hoisted_11, [_createElementVNode("span", null, _toDisplayString(connectMessage.value), 1)])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("a", {
        href: "javascript:;",
        class: "button-other",
        onClick: _cache[1] || (_cache[1] = $event => showFailDialog.value = false)
      }, " 关闭 "), _createElementVNode("a", {
        href: "javascript:;",
        onClick: copyClose
      }, " 复制并关闭 ")])])])) : _createCommentVNode("", true)], 64);
    };
  }
});